import {RsnInput} from '@raison/ui-kit';
import React from 'react';
import {createFormattingPlugin, createSelectionGetter} from '../../lib/forms/formatting';
import {Username} from '../../model/Username';

export function PhoneNumberInput({value, onChange, ...rest}: PhoneNumberInput.Props) {
    return (
        <RsnInput.Extended
            {...rest}
            type='tel'
            plugin={phoneFormatting}
            value={value}
            onChange={onChange}
            //
        />
    );
}

export namespace PhoneNumberInput {
    type Override<T, S extends Partial<Record<keyof T, any>>> = Omit<T, keyof S> & S;

    type OwnProps = {
        value: Username;
        onChange: (value: Username) => void;
        type?: undefined;
    };

    export type Props = Override<RsnInput.Props, OwnProps>;
}

export function getHelperText(error: Username.ValidationResult | undefined): string | undefined {
    switch (error!) {
        case 'INVALID_COUNTRY':
        case 'NOT_A_NUMBER':
        case 'TOO_SHORT':
        case 'TOO_LONG':
        case 'INVALID_LENGTH':
            return 'Invalid phone number';
        case 'REQUIRED':
            return 'This field is required';
    }
}

const selectionGetter = createSelectionGetter(value => /\d/g.test(value));
const selectAfterPlus: typeof selectionGetter = (target, value) => {
    const selection = selectionGetter(target, value);
    if (selection) {
        const [start, end] = selection;
        return [Math.max(start, 1), Math.max(end, 1)] as const;
    }
};

const phoneFormatting = createFormattingPlugin(
    selectAfterPlus,
    value => Username.fromString(value),
    username => username.formatted
);
